import { createPortal } from "react-dom";
import IconButton from "../../../../../design-system/components/IconButton/IconButton.jsx";
import Button from "../../../../../design-system/components/Button/Button.jsx";
import { Variants } from "../../../../../design-system/components/Button/Variants.jsx";
import { MUTATIONS, useMutation } from "../../../../../api";
import type { WorkshopId } from "../../../../../api/workshop";
import styles from "./Overlay.css";

export function constructIdentifier(workshopId: WorkshopId) {
  return `lastTimeLernreiseStateChecked-${workshopId}`;
}

/**
 * The Overlay component is a React component that renders an overlay on top of the current page.
 * We do this to know if the user has completed the Lernreise or not.
 * If the user clicks "Ja, weiter", we set the workshop as completed in the database.
 * If the user clicks "Nein, Ich schaue nur", we store the current timestamp in localStorage and
 * the overlay will appear again in 24 hours.
 */
const Overlay = ({
  workshopId,
  onClose,
}: {
  workshopId: WorkshopId;
  onClose: () => void;
}) => {
  const [doSetLernreiseCompleted, { isLoading }] = useMutation(
    MUTATIONS.setLernreiseCompleted,
  );
  const identifier = constructIdentifier(workshopId);

  async function handleClickCompleted() {
    try {
      await doSetLernreiseCompleted({ workshopId });
      localStorage.removeItem(identifier);
      onClose();
    } catch (err) {
      console.error("Failed to set Lernreise as completed:", err);
    }
  }

  function handleClickNotCompleted() {
    localStorage.setItem(identifier, Date.now().toString());
    onClose();
  }

  return (
    <>
      {createPortal(
        <div className={styles.outerDiv}>
          <div className={styles.innerDiv}>
            <div className={styles.containerCloseButton}>
              <IconButton
                name="xmark"
                size={"24px"}
                onClick={handleClickNotCompleted}
                aria-label="Schließen"
              />
            </div>
            <div className={styles.contentContainer}>
              <h1 className={styles.heading}>
                Kurze Frage:
                <br />
                Macht ihr gerade einen FREI DAY Kick-off in der Schule?
              </h1>
              <div className={styles.containerButton}>
                <Button width={"fit"} onClick={handleClickCompleted}>
                  {isLoading ? "Wird gespeichert..." : "Ja, weiter"}
                </Button>
                <Button
                  width={"fit"}
                  onClick={handleClickNotCompleted}
                  variant={Variants.SECONDARY}
                >
                  Nein, Ich schaue nur
                </Button>
              </div>
              <p className={styles.text}>
                *Als kostenfreies Angebot müssen wir verstehen, wie die Sparks
                verwendet werden. <br /> Mit deiner Antwort hilfst du uns
                ungemein.
              </p>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default Overlay;
